


export function Store() {
    return <div>
        ejemplo
    </div>
}